<template>
  <div>
    <!-- 投诉所属 -->
    <div class="tab_item" v-for="(item, index) in waitList" :key="index">
      <!-- 待响应，待处理，上报待审核 -->
      <ComplainItem :data="item" />
    </div>

    <div v-if="waitList.length > 0" class="view-more" @click="handleMore">
      <span class="view-more__text">查看全部</span>
      <van-icon :name="icons.icArrowRightGreen" class="view-more__ic"></van-icon>
    </div>
  </div>
</template>

<script>
import ComplainItem from './ComplainItem.vue'
import { handleToDoList } from '../../../../../utils/helper'
export default {
  name: 'IndexComplainToDo',
  components: {
    ComplainItem,
  },
  props: {
    waitList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      icons: {
        icArrowRightGreen: require('../../../../../assets/common/ic-arrow-right-green.png')
      }
    }
  },
  methods: {
    handleMore() {
      handleToDoList({type: '', name: '全部'})
    }
  }
}
</script>

<style lang="less" scoped>
.view-more {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 18px;
  &__ic {
    font-size: 12px !important;
  }
  &__text {
    font-size: 14px;
    line-height: 20px;
    margin-right: 2px;
    color: #229F60;
  }
}
</style>
